(function ($) {

	function add_cart_item(e) {

		e.preventDefault();

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=cart_add_product_variant",
			type: "post",
			dataType: "json",
			data: $(this).serializeArray(),
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('open_modal', ['cart'])
			})
	}

	function change_quantity() {
		let action = $(this).data('quantity-action')
		let $input = $(this).siblings("input[name='quantity']")
		let quantity = parseInt($input.val())
		switch (action) {
			case 'minus':
				if (quantity > 1) {
					$input.val(quantity - 1)
				}
				break;
			case 'plus':
				$input.val(quantity + 1)
				break;
		}
	}

	function init_cart() {
		// Add item to cart
		$('.product-detail-add-to-cart').off('submit').submit(add_cart_item)
		$('[data-quantity-action]').off('click').click(change_quantity)
	}

	// Init cart functions
	$(document).gp_ready(init_cart)

})(jQuery);
